import PreviewFileHelper from 'store/models/PreviewFileHelper';
import { alertsActions, showOverlayActions } from '.';
import { previewFileConstants } from 'store/constants';
import { UrlHelper } from 'store/helpers';
import {
  ApiAttachmentForFS,
  FormattedMainFile,
} from 'store/models/MainFiles';
import { ticketIdSelector } from 'store/selectors/ticket.selector';
import { EachPreviewedMergedFile } from 'store/models/BookingPreviews';

const previewFile = (
  file:
    | FormattedMainFile
    | ApiAttachmentForFS
    | EachPreviewedMergedFile,
) => {
  return (dispatch, getState) => {
    const { url, mimeType } = file;
    const fileM = new PreviewFileHelper(file);

    if ('locked' in file && file['locked']) {
      const ticketId = ticketIdSelector(getState());
      // dispatch(alertsActions.error(`This file is locked`));
      dispatch(
        showOverlayActions.show('InputPassword', {
          file,
          ticketId,
        }),
      );
    } else {
      if (fileM.isPdf()) {
        dispatch(previewFileActions.show(url, mimeType));
      } else if (fileM.isDownloadable()) {
        window.open(url, '_blank', 'noopener,noreferrer');
        // dispatch(alertsActions.success('Downloading'));
      } else {
        dispatch(
          alertsActions.error(
            `Cannot view file type ${fileM.getFileTypeFromMimeType()}`,
          ),
        );
      }
    }
  };
};

const show = (url: string, mimeType: string) => {
  const showPreview = (url: string, mimeType: string) => {
    return {
      type: previewFileConstants.PREVIEW_FILE_SHOW,
      payload: { url, mimeType },
    };
  };
  return (dispatch) => {
    if (UrlHelper.isValidUrl(url)) {
      dispatch(showPreview(url, mimeType));
    } else {
      dispatch(alertsActions.error(`url is not valid`));
    }
  };
};

const showPdfWithPagination = (
  currentIndex: number,
  allPages: { url: string; mimeType: string }[],
) => {
  return (dispatch) => {
    if (allPages.length === 1) {
      const page = allPages[0];
      dispatch(show(page.url, page.mimeType));
    } else {
      dispatch({
        type: previewFileConstants.PREVIEW_FILE_WITH_PAGE_SHOW,
        payload: {
          currentIndex,
          allPages,
        },
      });
    }
  };
};

const goNextPage = () => {
  return (dispatch, getState) => {
    const { currentIndex, allPages } = getState().previewFile;
    if (!allPages) throw Error(`can only use when has allPages`);
    if (
      currentIndex === undefined ||
      currentIndex + 1 >= allPages.length
    )
      throw Error(`invalid call`);
    dispatch({
      type: previewFileConstants.UPDATE_CURRENT_INDEX,
      payload: {
        index: currentIndex + 1,
      },
    });
  };
};
const goPrevPage = () => {
  return (dispatch, getState) => {
    const { currentIndex, allPages } = getState().previewFile;
    if (!allPages) throw Error(`can only use when has allPages`);
    if (currentIndex === undefined || currentIndex - 1 < 0)
      throw Error(`invalid call`);
    dispatch({
      type: previewFileConstants.UPDATE_CURRENT_INDEX,
      payload: {
        index: currentIndex - 1,
      },
    });
  };
};

const close = () => {
  return { type: previewFileConstants.PREVIEW_FILE_CLOSE };
};

export const previewFileActions = {
  show,
  close,
  previewFile,
  showPdfWithPagination,
  goNextPage,
  goPrevPage,
};
